import React from 'react'
import clsx from 'clsx'
import { useAppDispatch } from '../../../../../hooks/redux'

import { hideAlert } from '../../../../../slices/chatBoxSlice'
import useStyles, { getButtonColor } from './styles'

const CloseButton = ({ color, onClick, className }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    onClick={onClick}
    className={className}
  >
    <path
      d='M18 6L6 18'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6 6L18 18'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

const Alert = ({ alert }) => {
  const dispatch = useAppDispatch()

  const classes = useStyles()

  const handleHide = React.useCallback(() => {
    dispatch(hideAlert(alert.id))
  }, [dispatch, alert.id])

  return (
    <div className={clsx(classes.root, classes[`root_${alert.severity}`])}>
      <div className={classes.messages}>
        {alert.message.map((message, i) => (
          <div
            key={i}
            className={clsx(
              classes.message,
              classes[`message_${alert.severity}`]
            )}
          >
            {message}
          </div>
        ))}
      </div>

      <CloseButton
        color={getButtonColor(alert.severity)}
        onClick={handleHide}
        className={classes.button}
      />
    </div>
  )
}

export default Alert
